import type { MouseEvent } from 'react';

import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import DateRangeSelector from '../DateRangeSelector';
import GuestsRoomsChildrenSelect from '../GuestsRoomsChildrenSelect';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';

import STYLES from './ChappedLayoutSEO.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  checkInDate: Maybe<Date>;
  checkOutDate: Maybe<Date>;
  childrenAges: number[];
  adults: number;
  rooms: number;
  onDatesChanged: Function;
  onSubmit: Function;
  getGuestsRoomsChildren: Function;
  lightLabel?: boolean;
  i18n: I18nService;
};

const ChappedLayoutSEO = ({
  adults,
  checkInDate,
  checkOutDate,
  childrenAges,
  getGuestsRoomsChildren,
  i18n: { translate },
  lightLabel,
  onDatesChanged,
  onSubmit,
  rooms,
}: Props) => (
  <div className={cls('ChappedLayoutSEO')}>
    <div
      className={cls('ChappedLayoutSEO__inputsDates')}
      data-test-id="search-controls-datesguest"
    >
      <DateRangeSelector
        lightLabel={lightLabel}
        // @ts-expect-error TS2322: Type 'Maybe<Date>' is not assignable to type 'Date'.
        checkInDate={checkInDate}
        // @ts-expect-error TS2322: Type 'Maybe<Date>' is not assignable to type 'Date'.
        checkOutDate={checkOutDate}
        onDatesChanged={onDatesChanged}
        showNights
      />
    </div>
    <GuestsRoomsChildrenSelect
      className={cls('ChappedLayoutSEO__guestsRoomsChildren')}
      lightLabel={lightLabel}
      adults={adults}
      rooms={rooms}
      childrenAges={childrenAges}
      getGuestsRoomsChildren={getGuestsRoomsChildren}
      label={translate('HotelStay_label_guests_rooms')}
      hideLabel
    />
    <BpkButtonV2
      className={cls('SearchButton')}
      data-test-id="search-button-SEO"
      type={BUTTON_TYPES.primary}
      large
      onClick={(_e: MouseEvent<HTMLButtonElement>) => onSubmit()}
    >
      {translate('RoomsAndRates_HDP_search_rooms_rates_button')}
    </BpkButtonV2>
  </div>
);

export default withI18n(ChappedLayoutSEO);
